
export function formatFileSize(bytes: number): string {
    if (!bytes) {
        return '0 B';
    }
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}

/**
 * Convert a hex color into a 6-digit hex that looks like it has opacity applied on white background.
 *
 * @param hex - Original hex color (e.g. "#E600FF")
 * @param opacity - Opacity from 0 to 1 (e.g. 0.1 for 10%)
 * @returns 6-digit hex string blended onto white background
 */
export function hexToHexWithAlpha(hex: string, opacity: number): string {
    // normalize hex
    hex = hex.replace(/^#/, '');
    if (hex.length === 3) {
        hex = hex.split('').map(x => x + x).join(''); // expand shorthand
    }

    // parse R, G, B
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // blend with white background
    const blend = (channel: number) =>
        Math.round(channel * opacity + 255 * (1 - opacity));

    const rOut = blend(r);
    const gOut = blend(g);
    const bOut = blend(b);

    // convert back to hex
    return (
        '#' +
    [rOut, gOut, bOut]
        .map(x => x.toString(16).padStart(2, '0'))
        .join('')
        .toUpperCase()
    );
}
